import { HTMLProps, ReactNode } from "react";
import { cn } from "@/utils";

interface ReadOnlyInputProps extends HTMLProps<HTMLDivElement> {
  children?: ReactNode | ReactNode[];
  className?: string;
  onClick?: () => void;
}

export const ReadOnlyInput = ({
  children,
  className,
  ...props
}: ReadOnlyInputProps) => {
  return (
    <div
      className={cn(
        "p2-medium bg-surface-primary border-border flex w-full items-center rounded-lg border px-3 py-2.5",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
